/*
 * File: cc-cell.component.ts                                                  *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 10:07:23                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { fromEvent, Observable, Subscription } from 'rxjs';
import { CcGrid } from '../../../models/cc-grid.model';

import { CcGridCell } from '../../../models/cc-grid-cell.model';
import { CellService } from '../../../services/cell.service';
import { ProductService } from '../../../services/product.service';

import { Product, ProductVariant, ProductExtra, Cell } from '@nousmedis/cc-types';
import { ItemDropInterface } from 'app/modules/catalog-cloud/interfaces/item-drop.interface';
import { environment } from 'environment';
import { PageService } from '../../../services/page.service';

@Component({
  selector: 'app-cc-cell',
  templateUrl: './cc-cell.component.html',
  styleUrls: ['./cc-cell.component.scss'],
})
export class CcCellComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() cellId: number;
  @Input() grid: CcGrid;
  @Input() locked: boolean;
  @Input() idCatalog: string;
  @Input() idFascicle: string;
  @Input() idPage: string;


  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  allowChangeCells: boolean = environment.allow_change_cells;
  idCellPage: string;
  idRemoveImgBtn = '';
  cell: CcGridCell;
  subs = new Subscription();
  dragulaSelector: string;
  width = 0;
  height = 0;
  @Input() item: Product;
  itemId: string;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  cleanCell: Subscription;
  moveCell: Subscription;
  loading: boolean = true;

  viewItem: boolean = true;

  filled: boolean;

  constructor(
    private cellService: CellService,
    private productService: ProductService,
    private pageService: PageService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

  }

  /**
   * Lectura incorrecta de las medidas.
   * Volver a probar en el grid para la correcta medida de la celda
   */

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getCellSize();
    }, 1);
  }

  ngOnInit(): void {
    this.cell = this.grid.cells[this.cellId];
    this.idCellPage = this.cell.data.id;
    //console.log(this.cell)
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.idRemoveImgBtn = 'remove-img-' + this.idPage + '-' + this.cellId;
    if (this.cell.data.product) this.itemId = this.cell.data.product.id;

    //this.loadProduct();

    this.loading = false;

    this.itemId ? this.filled = true : this.filled = false;
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
      this.getCellSize();
    });
    this.listenForSubscriptions();
  }

  listenForSubscriptions() {
    this.cleanCell = this.cellService.cleanCell.subscribe((cellId) => {

      if (cellId === this.cell.data.id) {
        this.removeData();
      }
    });
    this.moveCell = this.cellService.moveCell.subscribe((cellId) => {
      if (cellId === this.cell.data.id) {
        this.moveData();
      }
    });
  }

  loadProduct() {
    this.loading = true;
    if (this.itemId) {
      this.productService
        .getProduct(this.idCatalog, this.itemId)
        .subscribe((product) => {
          this.item = product;
          if (this.item) this.filled = true;
          this.loading = false;
        });
    } else {
      this.loading = false;
      this.filled = false;
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.resizeSubscription$.unsubscribe();
    this.cleanCell.unsubscribe();
  }
  //67ac8d977464b77984f077ea

  dropCard(e: any) {

    const droppedProduct: ItemDropInterface = this.productService.dropProduct();
    if (droppedProduct.item && droppedProduct.item.id) {
      if (this.cell.data.product) {
        if (this.cell.data.product.id == droppedProduct.item.id) return;
      }
    }
    if (this.cell.data.product) {
      this.productService.removeProduct$.next((this.cell.data.product.id));
    }

    // Snapshot ANTES de cualquier mutación
    this.pageService.takeSnapshot('cell_update');

    if (droppedProduct.idCell != null) {

      //this.cellService
      this.cellService
        .moveProduct(
          this.idCatalog,
          this.idFascicle,
          droppedProduct.idPage,
          droppedProduct.idCell,
          this.idPage,
          this.cell.data.id
        )
        .subscribe((data: any) => {
          this.cellService.moveCell.next(droppedProduct.idCell);
          this.item = droppedProduct.item;
          this.cell.data.product = droppedProduct.item; //6/3/2023 Added id at cell -> data -> product
          this.cellService.cleanCell.next(droppedProduct.idCell);
          this.viewItem = true;
          this.filled = true;
        });
    } else {
      this.cell.data.product = droppedProduct.item;
      this.item = droppedProduct.item;
      this.viewItem = true;
      this.filled = true;
      this.cell.data.product.id = droppedProduct.item.id;
      this.updateCell(this.cell.data);
    }
  }

  updateCell(data: Cell) {
    this.cellService
      .update(this.idCatalog, this.idFascicle, this.idPage, data.id, data)
      .subscribe((product) => {
        if (data.product) {
          this.productService.addProduct$.next(data.product.id);
        }
      });
  }

  changeProductModel(productModel: string) {
    this.pageService.takeSnapshot('cell_update');
    this.cell.data.productModel = productModel;
    this.updateCell(this.cell.data);
  }

  changeProductVariant(productVariant: ProductVariant) {
    this.pageService.takeSnapshot('cell_update');
    this.cell.data.productVariant = productVariant;
    this.updateCell(this.cell.data);
  }

  changeProductExtra(productExtra: ProductExtra[]) {
    this.pageService.takeSnapshot('cell_update');
    this.cell.data.productExtra = productExtra;
    this.updateCell(this.cell.data);
  }

  getCellSize() {
    this.height =
      (document.getElementById('page-' + this.idPage).offsetHeight /
        this.grid.rows) *
      this.cell.data.rowWidth;

    this.width =
      (document.getElementById('page-' + this.idPage).offsetWidth /
        this.grid.columns) *
      this.cell.data.columnWith;
  }

  refreshCell() {
    this.getCellSize();
    console.log("Cell:", this.cell.data.cellNumber);
    console.log("Product:", this.cell.data.product);


  }

  removeData() {
    if (this.cell.data.product) {
      this.pageService.takeSnapshot('cell_update');
      this.productService.removeProduct$.next(this.cell.data.product.id);
      this.item = null;
      this.cell.data.product = null;
      this.cell.data.productModel = null;
      this.cell.data.productVariant = null;
      this.cell.data.productExtra = [];
      this.updateCell(this.cell.data);
    }
  }

  moveData() {
    this.item = null;
    this.cell.data.product = null;
    this.cell.data.productModel = null;
    this.cell.data.productVariant = null;
    this.cell.data.productExtra = [];
    this.updateCell(this.cell.data);
  }

  entering(e: any) {
    this.viewItem = false;
  }

  exiting(e: any) {
    this.viewItem = true;
  }
}
